import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material';
import { RootState } from 'store';
import { setTypes } from 'store/marketplace/actions';
import { IMarketPlaceState } from 'store/marketplace/types';
import Strings from 'utils/Strings';
import { typeItems } from 'constants/filters/Items';
import { ItemType } from 'models/Filters';
import FilterCard from 'components/common/filter-card';
import FilterContainer from 'components/common/filter-container';

const ItemTypes: React.FunctionComponent = () => {
  const theme = useTheme();
  const { types } = useSelector<RootState, IMarketPlaceState>(state => state.MarketPlace);
  const dispatch = useDispatch();

  const onSelectHandler = (key: ItemType) => {
    const index = types.findIndex(item => item === key);
    if (index === -1) {
      types.push(key);
      dispatch(setTypes(types));
    } else {
      types.splice(index, 1);
      dispatch(setTypes(types));
    }
  };

  return (
    <FilterContainer
      className="mt-3"
      title={Strings.types}
      count={types.length > 0 ? types.length : undefined}
      body={
        <div className="d-flex flex-wrap align-items-center justify-content-center mb-3">
          {typeItems.map(({ icon: Icon, type }) => (
            <FilterCard
              key={type}
              icon={<Icon color={theme.palette.purple} />}
              text={type}
              onClick={() => onSelectHandler(type)}
              active={types.includes(type)}
              purpleMode
            />
          ))}
        </div>
      }
    />
  );
};
export default ItemTypes;
